
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiVesselTypeBargeOutlined as ObiVesselTypeBargeOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-vessel-type-barge-outlined.js';
 
 
 

 
 export const ObiVesselTypeBargeOutlined = createComponent({
   react: React,
   tagName: 'obi-vessel-type-barge-outlined',
   elementClass: ObiVesselTypeBargeOutlinedElement,
   events: {
     
   }
  });
 
 